import React, { useState } from "react";
import { BarcodeFakeLink } from "./BarcodeLinkStyles";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import ContainerPage from "../ContainerPage";

export function ContainerModalLink({
  containerBarcode,
  onUpdate,
}: {
  containerBarcode: string;
  onUpdate?: () => void;
}) {
  const [containerModalIsOpen, setContainerModalIsOpen] = useState(false);

  const closeModal = () => {
    setContainerModalIsOpen(false);
  };

  return (
    <>
      <BarcodeFakeLink onClick={() => setContainerModalIsOpen(true)}>
        {containerBarcode}
      </BarcodeFakeLink>
      <Modal isOpen={containerModalIsOpen} onRequestClose={closeModal}>
        <ModalContentWithCloseButton closeModal={closeModal} lessPadding>
          <ContainerPage
            containerBarcode={containerBarcode}
            onUpdate={onUpdate}
          />
        </ModalContentWithCloseButton>
      </Modal>
    </>
  );
}
